module.exports = __webpack_public_path__ + "img/book-half.6e5bee0f.svg";